import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { routeMap } from '@/routes/routeMap';

const LoanWithdrawalSuccess = ({ payload, closeModal }: ModalProps<{ transactionId: string }>) => {
  const { t } = useTranslation('Modal', { keyPrefix: 'LoanWithdrawalSuccess' });

  return (
    <Modal title={t('title')}>
      <p>{t('body')}</p>
      <ModalActions>
        <LinkButton to={routeMap.loan.monthlyPayment} onClick={closeModal}>
          {t('button')}
        </LinkButton>
        <LinkButton
          variant="secondary"
          to={routeMap.fairnessReceipt.transactionId(payload.transactionId)}
          onClick={closeModal}
        >
          {t('fairnessReceiptButton')}
        </LinkButton>
      </ModalActions>
    </Modal>
  );
};

export default LoanWithdrawalSuccess;
